import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { SharedModule } from "../shared/shared.module";
import { ApgAddClaimComponent } from "./apg-add-claim/apg-add-claim.component";
import { ApgBenefitPaymentsComponent } from "./apg-benefit-payments/apg-benefit-payments.component";
import { ApgConditionsComponent } from "./apg-conditions/apg-conditions.component";
import { ApgGraphComponent } from "./apg-graph/apg-graph.component";
import { ApgMultiClaimCalculatorComponent } from "./apg-multi-claim-calculator.component";
import { ApgSumAssuredComponent } from "./apg-sum-assured/apg-sum-assured.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxSliderModule,
    CurrencyMaskModule,
    SharedModule
  ],
  exports: [ApgMultiClaimCalculatorComponent],
  declarations: [
    ApgMultiClaimCalculatorComponent,
    ApgSumAssuredComponent,
    ApgGraphComponent,
    ApgConditionsComponent,
    ApgBenefitPaymentsComponent,
    ApgAddClaimComponent
  ]
})
export class ApgMultiClaimCalculatorModule { }
